if (!customElements.get('read-more-toggle')) {
  class ReadMoreToggle extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.product__read-more-button');
      this.textEl = this.querySelector('.product__read-more-text');
      this.content = this.querySelector('.product__read-more-content');

      if (!this.button || !this.textEl || !this.content) return;

      this.readMoreText = this.textEl.textContent;
      this.readLessText = this.getAttribute('data-read-less') || this.readMoreText;

      this.button.addEventListener('click', () => {
        const isHidden = this.content.hidden;

        this.content.hidden = !isHidden;
        this.textEl.textContent = isHidden ? this.readLessText : this.readMoreText;
        this.button.setAttribute('aria-expanded', String(isHidden));
      });
    }
  }

  customElements.define('read-more-toggle', ReadMoreToggle);
}
